<template>
    <app-collapse-item
        :title="component.component.title"
        :is-visible="component.substances.length > 0 || false === component.component.hasConcernSubstances"
        :is-collapsible="component.substances.length > 0"
        ref="accordion"
    >
        <template #header>
            <div>
                <span class="h5" v-for="(title, index) in componentHeader">
                    <feather-icon
                        v-if="index > 0"
                        icon="ChevronRightIcon"
                    />
                    {{ title }}
                </span>
            </div>
            <div class="d-flex justify-content-end">
                <div :class="['has-concern-substances-radio-text mr-1', headerMessageKey.variant]">
                    <span>{{ $t(headerMessageKey.key) }}</span>
                </div>
                <SelectConcernElementsButton
                    class="ml-1 mr-2 float-right"
                    @selectConcernElements="selectComponentConcernElements"
                />
            </div>
        </template>
        <b-overlay
            variant="white"
            :show="showLoading"
            spinner-variant="primary"
            blur="0"
            opacity=".85"
            rounded="sm"
        >
            <ConcernElementsModal
                :ref="'componentConcernElementsModal' + component.component.id"
                :product="product"
                :included-substances="includedSubstances"
                :excluded-substances="excludedSubstances"
                :company-has-information="true"
                :instruction="$t('Page(ReceivedRequest):Component(ConcernElementsModal):hint')"
                :legislations="legislations.map(l => l.id)"
                @listQuestionStateUpdated="listQuestionStateUpdated"
                @include="include"
                @exclude="excludeSubstance"
                @undefined="makeUndefined"
                @modalClosed="modalClosed"
            />
            <Transition name="zoom-fade">
                <b-alert
                    class="ml-2 mr-2 mb-2"
                    variant="success"
                    :show="!hasConcernElements && false === component.component.hasConcernSubstances"
                >
                    <div class="alert-body">
                        {{ $t('Component(Text):component-does-not-have-concern-substances') }}
                    </div>
                </b-alert>
            </Transition>
            <component
                :is="substanceRenderer"
                v-if="false === collapsed"
                v-for="substance in component.substances"
                :key="substance.substance.id"
                :read-only="false"
                :compact-view="compactView"
                :substance="substance"
                :substance-lists="substanceLists"
                @exclude="exclude"
                @change="substanceConfigurationChanged"
            />
        </b-overlay>
    </app-collapse-item>
</template>

<script>
import {BCard, BAlert, BRow, BCol, BListGroup, BListGroupItem, BFormRadio, BOverlay, BButton,
    BFormCheckbox, BCollapse } from 'bootstrap-vue'
import {ConcernElementPlacementOrder} from "@core/domain/product";
import SelectOrMakeProduct from "@core/components/product/SelectOrMakeProduct";
import Ripple from 'vue-ripple-directive'
import {ProductProvider} from "@core/domain/product";
import SelectConcernElementsButton
    from "@/views/request/received/flow/components/vertiacal-steps/SelectConcernElementsButton";
import ConcernElementsModal from "@/views/product/components/product-card/ConcernElementsModal";
import OrderSelector from "@/views/request/received/flow/components/vertiacal-steps/OrderSelector";
import AppendComponentListItem from "@/views/request/received/flow/components/concern-element/AppendComponentListItem";
import InsertIntermediateComponent
    from "@/views/request/received/flow/components/concern-element/InsertIntermediateComponent";
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import {
    DEFAULT_SUBSTANCE_COMPONENT,
    resolveSubstanceComponent,
} from '@/views/product/components/product-card/composition/substance-editor/registry'
import {SubstanceState} from "@/libs/product";
import InstructionText from "@core/components/common/instructions/InstructionText.vue";

export default {
    directives: {Ripple},
    components: {
        InstructionText,
        BCard, BRow, BCol, BListGroup, BListGroupItem, BFormRadio, BOverlay, BButton,
        SelectOrMakeProduct, SelectConcernElementsButton, ConcernElementsModal, OrderSelector, BAlert,
        InsertIntermediateComponent, AppendComponentListItem, BFormCheckbox, BCollapse, AppCollapseItem,
    },
    props: {
        substanceLists: {
            type: Array,
            default() {
                return [];
            }
        },
        legislations: {
            required: true,
        },
        compactView: {
            type: Boolean,
            default: false
        },
        component: {
            type: Object
        },
        additionalMaterials: {
            type: Array,
            default() {
                return [];
            }
        },
        materialCategories: {
            type: Array,
            default() {
                return [];
            }
        },
        mixtureCategories: {
            type: Array,
            default() {
                return []
            }
        },
        isMaterialCategoryMandatory: {
            type: Boolean,
            required: true
        },
        substanceComponent: {
            type: String,
            default: DEFAULT_SUBSTANCE_COMPONENT,
        }
    },
    data() {
        return {
            hasChangesInConcernElementsModal: false,
            hasChangesForListQuestionStates: false,

            collapsed: false,
            order: this.defaultOrder,
            hierarchy: this.cloneHierarchy(),
            substanceState: this.component.state || null,
            saveTimeoutId: null,
            showLoading: false,
            isAppend: false,
            isIntermediate: false,
            includedSubstances: [],
            excludedSubstances: [],
            isOrderSelectorDisabled: false,
            hasConcernSubstancesCheckboxValue: this.calculateHasConcernSubstancesCheckboxValue(),
            product: {
                title: null,
                names: []
            },

            substancesLoaded: false
        };
    },
    methods: {
        calculateHasConcernSubstancesCheckboxValue() {
            return this.component.component.hasConcernSubstances;
        },
        loadSubstances() {
            if (this.substancesLoaded) {
                return new Promise(resolve => resolve());
            }
            this.substancesLoaded = true;
            return ProductProvider(this.component.component.id)
                .getSubstances()
                .then(({included, excluded}) => {
                    this.excludedSubstances = excluded;
                    this.includedSubstances = included;
                })
        },
        selectComponentConcernElements() {
            this.showLoading = true;
            Promise.all([
                this.loadSubstances(),
                ProductProvider(this.component.component.id).getCard().then(card => this.product = card),
            ]).then(() => {
                this.showLoading = false;
                this.$refs['componentConcernElementsModal' + this.component.component.id].show();
            })
            // this.loadSubstances().then(() => {
            //     this.$refs['componentConcernElementsModal' + this.component.component.id].show();
            // });
        },
        cloneHierarchy() {
            let flatHierarchy = this.component.parents.map(i => i);

            if (this.canModifyHierarchy()) {
                let currentComponent = flatHierarchy.splice(flatHierarchy.length - 1, 1);

                let order = this.order || ConcernElementPlacementOrder.TOP_DOWN;
                if (order === ConcernElementPlacementOrder.TOP_DOWN) {
                    flatHierarchy.push(currentComponent[0]);
                    flatHierarchy.push({
                        hierarchyModifier: true,
                        append: true,
                    });
                } else {
                    flatHierarchy.push({
                        hierarchyModifier: true,
                        insert: true
                    });
                    flatHierarchy.push(currentComponent[0]);
                }
            }

            return flatHierarchy;
        },
        updateSubstanceState(productDomain) {
            return productDomain
                .getSubstanceState(this.legislationIds)
                .then(state => {
                    this.substanceState = state;
                    this.component.state = state;
                    this.$emit('stateUpdated', state);
                });
        },
        listQuestionStateUpdated(list, state) {
            ProductProvider(this.component.component.id).updateListQuestionState(list, state);
            this.hasChangesForListQuestionStates = true;
        },
        modalClosed() {
            if (this.hasChangesForListQuestionStates) {
                ProductProvider(this.component.component.id).saveCard();
                this.hasChangesForListQuestionStates = false;
            }
            if (!this.hasChangesInConcernElementsModal) {
                return;
            }

            this.hasChangesInConcernElementsModal = false;
            this.showLoading = true;

            const product = ProductProvider(this.component.component.id);
            product
                .saveSubstances()
                .then((state) => {
                    if (this.component.substances.length > 0 && true !== this.component.component.hasConcernSubstances) {
                        this.component.component.hasConcernSubstances = true;
                    }
                    this.$emit('substancesSaved');
                    return this.updateSubstanceState(product);
                })
                .finally(() => this.showLoading = false)
            ;

            // if (this.component.concernElements.length > 0) {
            if (this.component.substances.length > 0) {
                this.expand();
            // } else if (this.component.concernElements.length === 0) {
            } else if (this.component.substances.length === 0) {
                this.collapse();
            }
        },

        expand() {
            this.$refs.accordion.updateVisible(true);
        },

        collapse() {
            if (false !== this.component.component.hasConcernSubstances) {
                this.$refs.accordion.updateVisible(false);
            }
        },

        include(substance) {
            this.hasChangesInConcernElementsModal = true;
            substance = ProductProvider(this.component.component.id).includeSubstance(substance);
            this.component.substances.push(substance);
            this.hasConcernSubstancesCheckboxValue = true;
            this.$emit('substanceIncluded', this.component, substance);
        },

        makeUndefined(substance) {
            this.hasChangesInConcernElementsModal = true;
            this.loadSubstances()
                .then(() => {
                    ProductProvider(this.component.component.id).makeSubstanceUndefined(substance);
                    let index = this.component.substances.findIndex(c => c.substance.id === substance.id);
                    if (index >= 0) {
                        this.component.substances.splice(index, 1);
                    }
                });
        },

        excludeSubstance(substance) {
            this.hasChangesInConcernElementsModal = true;
            this.doExclusion({substance}, false);
        },
        exclude(concernElement) {
            this.doExclusion(concernElement, true);
        },

        doExclusion(concernElement, doSave) {
            this.loadSubstances()
                .then(() => {
                    const componentId = this.component.component.id;
                    ProductProvider(componentId).excludeSubstance(concernElement.substance);

                    let index = this.component.substances.findIndex(c => c.substance.id === concernElement.substance.id);
                    if (index >= 0) {
                        this.component.substances.splice(index, 1);
                        this.$emit('substanceExcluded', this.component, concernElement.substance);

                        if (this.component.substances.length === 0) {
                            this.hasConcernSubstancesCheckboxValue = null;
                            // in this case we need to save substances and only then update hasConcernElements
                            this.doSave().then(() => {
                                this.$emit('substanceExcludedAndSaved', this.component, concernElement.substance);
                                const product = ProductProvider(componentId);
                                product.getCard().then(() => {
                                    product.setHasConcernSubstances(null);
                                    product.saveCard();
                                    this.component.component.hasConcernSubstances = null;
                                    this.collapse();
                                });
                            })
                        } else if (doSave) {
                            this.doSave().then(() => {
                                this.$emit('substanceExcludedAndSaved', this.component, concernElement.substance)
                            });
                        }
                    }
                });
        },

        substanceConfigurationChanged(substance, properties) {
            const updateSubstance = () => {
                const includedSubstance = this.includedSubstances.find(s => s.substance.id === substance.substance.id);

                if (includedSubstance) {
                    includedSubstance.properties = properties;
                }
            };
            if (!this.substancesLoaded) {
                this.showLoading = true;
                this
                    .loadSubstances()
                    .then(() => {
                        updateSubstance();
                        this.doSave();
                    });
            } else {
                updateSubstance();
                this.save();
            }
        },

        save() {
            clearTimeout(this.saveTimeoutId);
            this.saveTimeoutId = setTimeout(() => {
                this.doSave();
            }, 3500);
        },

        doSave() {
            this.showLoading = true;

            const product = ProductProvider(this.component.component.id);
            let promise = new Promise((resolve, reject) => {
                resolve();
            });

            if (!this.substancesLoaded) {
                promise = this.loadSubstances();
            }

            return promise.then(() => {
                return product
                    .saveSubstances()
                    .then(() => {
                        return this.updateSubstanceState(product);
                    })
                    .finally(() => this.showLoading = false);
            });
        },

        canModifyHierarchy() {
            return 0 === this.component.substances.length;
        },
    },
    computed: {
        substanceRenderer() {
            return resolveSubstanceComponent(this.substanceComponent)
        },
        legislationIds() {
            return this.legislations
                .filter((value, index, array) => array.indexOf(value) === index)
                .map(l => l.id)
            ;
        },
        mainCardClasses() {
            return {
                'component-concern-elements': true,
                'has-concern-elements': this.component.substances.length > 0,
                'no-concern-elements': this.component.substances.length === 0,
                'collapsed': this.collapsed
            };
        },
        isDoesNotHaveConcernElementsCheckboxVisible() {
            return this.component.substances.length === 0;
        },
        showSelectConcernElementsButton() {
            return false !== this.component.component.hasConcernSubstances;
        },
        radioName() {
            return 'order_' + this.component.component.id;
        },
        hasConcernElements() {
            return this.component.substances.length;
        },
        defaultOrder() {
            return this.component.order || ConcernElementPlacementOrder.TOP_DOWN;
        },
        componentHeader() {
            return this.hierarchy
                .filter(h => h.hierarchyModifier === undefined)
                .slice(1)
                .map(c => c.title);
        },
        hasConcernSubstances() {
            return this.component.component.hasConcernSubstances;
        },
        headerMessageKey() {
            switch (this.substanceState) {
                case SubstanceState.ALL_DEFINED_DOES_NOT_INCLUDE_SUBSTANCES:
                    return {
                        key: 'Page(ReceivedRequest):Component(ConcernElements):message-all-declared-not-includes',
                        variant: 'text-success'
                    };

                case SubstanceState.ALL_DEFINED_INCLUDES_SUBSTANCES:
                    return {
                        key: 'Page(ReceivedRequest):Component(ConcernElements):message-all-declared-includes',
                        variant: 'text-success'
                    };

                case SubstanceState.SOME_DEFINED_DOES_NOT_INCLUDE_SUBSTANCES:
                case SubstanceState.SOME_DEFINED_INCLUDES_SUBSTANCES:
                case SubstanceState.ALL_UNDEFINED:
                default:
                    return {
                        key: 'Page(ReceivedRequest):Component(ConcernElements):message-not-all-declared',
                        variant: 'text-danger'
                    };
            }
        },
    },
    watch: {
        hasConcernSubstances() {
            this.hasConcernSubstancesCheckboxValue = this.calculateHasConcernSubstancesCheckboxValue();

            if (false === this.hasConcernSubstancesCheckboxValue) {
                this.expand();
            }
        },
        component() {
            this.hierarchy = this.cloneHierarchy();
            this.substanceState = this.component.state;
            this.isOrderSelectorDisabled = this.component.order !== undefined;
            this.hasConcernSubstancesCheckboxValue = this.calculateHasConcernSubstancesCheckboxValue();
        }
    }
}
</script>

<style lang="scss">
.component-concern-elements.bg-light {
    .card {
        //border: none;

        .card-body {
            padding: 1rem;
        }
    }
}
.component-concern-elements {
    .has-concern-substances-radio-text {
        font-size: 1rem;
        font-weight: 400;
    }
}
</style>
